import React from 'react'
import { Header, Image } from 'semantic-ui-react'
import { DrawButton } from '../button'

function Advertising(props) {
  const { isOpen, onClose, data } = props

  const isMobile = window.innerWidth < 768

  if (!isOpen || !data) return null

  const {
    headline,
    subline,
    content,
    image,
    card,
    btnText,
    btnHandleOnClick
  } = data

  const overlayStyle = {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }

  const modalStyle = {
    position: 'relative',
    backgroundColor: '#fff',
    maxWidth: '1100px',
    width: '90%',
    borderRadius: '6px',
    overflow: 'hidden',
    boxShadow: '0 10px 40px rgba(0,0,0,0.3)'
  }

  const articleStyle = {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    minHeight: isMobile ? 'auto' : '730px',
    maxHeight: isMobile ? '80vh' : 'none',
    overflow: 'hidden'
  }

  const imageWrapperStyle = {
    width: isMobile ? '100%' : '55%',
    height: isMobile ? '180px' : 'auto',
    position: 'relative',
    overflow: 'hidden'
  }

  const imageStyle = {
    position: 'absolute',
    inset: 0,
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    filter: 'grayscale(20%) brightness(0.85)'
  }

  const imageFadeStyle = {
    position: 'absolute',
    inset: 0,
    background:
      'linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)'
  }

  const contentStyle = {
    width: isMobile ? '100%' : '45%',
    padding: isMobile ? '1.5rem' : '3rem',
    boxSizing: 'border-box',
    overflowY: 'auto'
  }

  const closeStyle = {
    position: 'absolute',
    top: '10px',
    right: '15px',
    fontSize: '28px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    lineHeight: 1,
    zIndex: 1001
  }

  const cardStyle = {
    marginTop: '2rem'
  }

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>

        <button style={closeStyle} onClick={onClose}>
          ×
        </button>

        <article style={articleStyle}>

          <div style={imageWrapperStyle}>
            <div style={imageStyle} />
            <div style={imageFadeStyle} />
          </div>

          <div style={contentStyle}>
            <Header className="headline-regular" as="h1">
              {headline}
            </Header>

            <Header className="headline-bag" as="h3">
              {subline}
            </Header>

            {content && (
              <div
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}

            {btnHandleOnClick && btnText && (
              <p>
                <DrawButton
                  name={btnText}
                  onClick={btnHandleOnClick}
                />
              </p>
            )}

            {card && (
              <div style={cardStyle}>
                <Image
                  alt={headline}
                  size="tiny"
                  src={card}
                  style={{ width: '300px' }}
                />
              </div>
            )}
          </div>

        </article>
      </div>
    </div>
  )
}

export default Advertising